import { render } from "./ArchSwitcherPane.vue?vue&type=template&id=570edb2c&scoped=true&ts=true"
import script from "./ArchSwitcherPane.vue?vue&type=script&lang=ts"
export * from "./ArchSwitcherPane.vue?vue&type=script&lang=ts"

import "./ArchSwitcherPane.vue?vue&type=style&index=0&id=570edb2c&scoped=true&lang=css"
import "./ArchSwitcherPane.vue?vue&type=style&index=1&id=570edb2c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-570edb2c"]])

export default __exports__